import { DatePicker } from 'antd';
import React from 'react';
import './styles.scss';

import nor from 'antd/es/date-picker/locale/nb_NO';
import 'dayjs/locale/nb';
import * as relativeTime from 'dayjs/plugin/relativeTime';
import dayjs from 'dayjs';
import i18next from 'i18next';

dayjs.extend(relativeTime);

function AdminFormDate({
  value,
  onChange,
  name = 'Field name',
  disabled = false,
  error = '',
  placeholder,
}) {
  return (
    <div className='AdminFormDate' style={{ opacity: disabled ? 0.4 : 1 }}>
      <div className='AdminFormDate__name'>{name}</div>
      <div>
        <DatePicker
          className='AdminFormDate__date-input'
          value={value}
          placeholder={placeholder || name}
          onChange={onChange}
          locale={i18next.languages.some((x) => x === 'nor') ? nor : undefined}
        />
        {error && <div className='AdminFormDate__error'>{error}</div>}
      </div>
    </div>
  );
}

export default AdminFormDate;
